import React, { useEffect, useState } from "react";
import { 
    Box, 
    Typography, 
    Link,
    createTheme,
    styled,
    CssBaseline,
    Toolbar,
    IconButton,
    ThemeProvider,
    Divider,
    List,
    Container,
    Grid,
} from "@mui/material";
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import { Route, Routes } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { mainListItems } from "../../components/mainListItems";
import SidebarWeb from "../../components/SidebarWeb";
import DashboardInicioWeb from "./DashboardInicioWeb";
import DashboardContantanosWeb from "./DashboardContantanosWeb";
import DashboardServicioWeb from "./DashboardServicioWeb";
import DashboardVisionWeb from "./DashboardVisionWeb";
import DashboardProgramasWeb from "./DashboardProgramasWeb";
import DashboardBlogWebWeb from "./DashboardBlogWeb";
import DashboardCertificadosWeb from "./DashboardCertificadosWeb";
import MainDashboard from "./MainDashboard";
import BotonCerrarSesion from "../../components/BotonCerrarSesion";

function Copyright(props) {
    return (
      <Typography variant="body2" color="#5d0303" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="">
        Calocho Usugha
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
}

const drawerWidth = 240;


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9),
        },
    }),
    },
}),
);
  
  // TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

const Dashboard = () => {
    const [open, setOpen] = useState(true);

    // Al cargar la página, recupera el estado de la barra lateral desde el localStorage
    useEffect(() => {
      const isOpen = localStorage.getItem('sidebarOpen');
      if (isOpen !== null) {
        setOpen(isOpen === 'true');
      }
    }, []);

    // Cuando el usuario cambia el estado de la barra lateral, guarda ese estado en el localStorage
    const toggleDrawer = () => {
      const newOpen = !open;
      setOpen(newOpen);
      localStorage.setItem('sidebarOpen', newOpen.toString());
    };

    return(
        <ThemeProvider theme={defaultTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
            <AppBar position="absolute" open={open}>
              <Toolbar
                sx={{
                  pr: '24px', // keep right padding when drawer closed
                  background: '#5d0303',
                }}
              >
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  sx={{
                    marginRight: '36px',
                    ...(open && { display: 'none' }),
                  }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >
                  Calocho Usugha
                </Typography>
                {/**Cerrar sesion**/}
                <BotonCerrarSesion />
                </Toolbar>
            </AppBar>
          <Drawer variant="permanent" open={open}>
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
              }}
            >
              <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List component="nav">
              {mainListItems}
              <Divider sx={{ my: 1 }} />
              <SidebarWeb />
            </List>
          </Drawer>
          <Box
            component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                    
                <Routes>
                    <Route path="" element={<MainDashboard />}/>
                    <Route path="inicio" element={<DashboardInicioWeb />}/>
                    <Route path="servicio" element={<DashboardServicioWeb />}/>
                    <Route path="vision" element={<DashboardVisionWeb />}/>
                    <Route path="programa" element={<DashboardProgramasWeb />}/>
                    <Route path="blog" element={<DashboardBlogWebWeb />} />
                    <Route path="certificados" element={<DashboardCertificadosWeb />}/>
                    <Route path="contactanos" element={<DashboardContantanosWeb />}/>
                </Routes>
                </Grid>
            </Container>
            <Copyright sx={{ pt: 4 }} />
          </Box>
        </Box>
      </ThemeProvider>
    );
}

export default Dashboard;